import Vue from 'vue'

import router from '@/router';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
};

// getters
const getters = {};

// actions
const actions = {
  linelogin() {
    //- 直接打 login 拿新的 token
    Vue.prototype.$frontendAxios.post(`${process.env.VUE_APP_FUBON_FRONTEND_API_URL}/login`, {
      line_uuid: Vue.prototype.$line_uuid
    })
    .then(response => {
      //- 更新 token
      window.localStorage.removeItem('token');
      localStorage.setItem('token', response.data.data.access_token ? response.data.data.access_token : null);
      //- 判斷是否綁定了 綁定了就轉到首頁
      if (response.data.data.is_bind === true) {
        let from_url = localStorage.getItem('from_url');
        let routeName = from_url && from_url.indexOf('editMember') > -1 ? 'edit_member' : 'home';
        // 導到首頁
        router.push({
          name: routeName
        }).catch(err => {
            console.error(err);
          });
      } else if (response.data.data.is_bind === false) {
        //- 導到綁定頁面
        router.push({
          name: 'sign_up'
        }).catch(err => {
            console.error(err);
          });
      } else {
        //- 其他都直接倒到 Login 頁面
        router.push({ name: 'login' })
          .catch(err => {
            console.error(err);
          });
      }
    })
    .catch(error => {
      console.error('[Error:login失敗, VueX Login Catch]', error);
    })
  },
};

// mutations
const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
